<script>
	import "../shared.css";
    import { getNewIcon } from "../../card_images";

	export let score;

	const iconWidths = {
		research: 1.25,
		influence: 1.5,
		military: 1.4,
		treachery: 1.3
	};
</script>

<div class="tr-black" />
<div class="tr-focus {score}" />
<div class="score-icons">
	<img src={getNewIcon(score)} style={`width:${iconWidths[score]}em;`} /> <!-- height: 1.4em-->
	<img src={getNewIcon('?vp')} style="height:1.6em" />
</div>

<style lang="scss">
	.score-icons {
		position: absolute;
		width: min-content;
		height: min-content;
		display: flex;
		top: calc(0px - var(--height) / 80.2); // -5px;
		right: 0.45em;
		align-items: flex-end;
		z-index: 10;
	}
	.tr-black {
		position: absolute;
		width: calc(var(--width) / 15.944); //18px;
		height: calc(var(--height) / 16.04); //25px; // make same
		clip-path: polygon(100% 0, 100% 100%, 0 100%);
		background: black;
		right: 0;
		bottom: -0.05em;
		z-index: 2;
	}
	.tr-focus {
		position: absolute;
		width: calc(var(--width) / 4.783); //60px;
		height: calc(var(--height) / 7.291); //55px;
		clip-path: polygon(100% 0, 100% 100%, 0 100%);
		right: 0;
		bottom: -0.05em;
		z-index: -4;
	}
	.research {
		background-image: linear-gradient(
			215deg,
			rgba(30, 30, 30, 1) 0%,
			rgb(14, 134, 214) 15%,
			rgba(45, 167, 215, 1) 40%,
			rgb(14, 134, 214) 65%,
			rgba(30, 30, 30, 1) 100%
		);
	}
	.influence {
		background-image: linear-gradient(
			215deg,
			rgba(30, 30, 30, 1) 0%,
			rgba(193, 180, 0, 1) 15%,
			rgba(233, 220, 32, 1) 40%,
			rgba(193, 180, 0, 1) 65%,
			rgba(30, 30, 30, 1) 100%
		);
	}
	.military {
		background-image: linear-gradient(
			215deg,
			rgba(30, 30, 30, 1) 0%,
			rgba(171, 0, 59, 1) 15%,
			rgba(210, 38, 98, 1) 40%,
			rgba(171, 0, 59, 1) 65%,
			rgba(30, 30, 30, 1) 100%
		);
	}
	.treachery {
		background-image: linear-gradient(
			215deg,
			rgba(1, 10, 24, 1) 0%,
			rgba(189, 107, 11, 1) 15%,
			rgba(247, 147, 29, 1) 40%,
			rgba(189, 107, 11, 1) 65%,
			rgba(30, 30, 30, 1) 100%
		);
	}
</style>
